import client from './client'

const unwrapData = (res) => res.data?.data

export const getDiagnosticos = (params) =>
  client.get('/diagnosticos', { params }).then(unwrapData)

export const getDiagnosticoPdfUrl = (id) =>
  client.get(`/diagnosticos/${id}/pdf`).then(unwrapData)

export const getDiagnosticoInvestigacionUrl = (id) =>
  client.get(`/diagnosticos/${id}/investigacion`).then(unwrapData)